<template>
	<div>
		<SubscribeMap :items="neighbourhoods" :api_url="$NEIGHBOURHOOD_API" v-on:choose="choose" column_name="location"></SubscribeMap>
	</div>
</template>

<script>
	import SubscribeMap from '@/components/SubscribeMap';

	export default {
		props: ['neighbourhoods'],
		components: { SubscribeMap },
		data() {
			return {
				
			}
		},
		methods: {
			choose(neighbourhoods) {
				this.$emit('choose',neighbourhoods);
			}
		}
	}

</script>

<style scoped>

</style>